import React from 'react';

import { Skeleton, TableCell, TableRow } from '@packages/fenrir/components';

export const AssetIpTableRowSkeleton: React.FC = () => {
  return (
    <TableRow>
      <TableCell sx={{ borderBottom: 'none', m: 0, pl: 0, pr: 4, py: 0 }}>
        <Skeleton width="5rem" />
      </TableCell>
      <TableCell sx={{ borderBottom: 'none', pl: 0, pr: 4, py: 0 }}>
        <Skeleton width="6rem" />
      </TableCell>
      <TableCell sx={{ borderBottom: 'none', pl: 0, pr: 4, py: 0 }}>
        <Skeleton width="6rem" />
      </TableCell>
    </TableRow>
  );
};
